"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApplicationFailure = createApplicationFailure;
exports.createApplicationRequest = createApplicationRequest;
exports.createApplicationSuccess = createApplicationSuccess;
exports.createContract = createContract;
exports.createContractError = createContractError;
exports.createContractForAPIGroup = createContractForAPIGroup;
exports.createContractRequest = createContractRequest;
exports.createContractSuccess = createContractSuccess;
exports.openRequestAccessModal = openRequestAccessModal;
exports.resetModalState = resetModalState;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _exchangeApiClient = require("@mulesoft/exchange-api-client");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var actions = _interopRequireWildcard(require("./actionTypes"));
var _store = require("../../../api-group/store");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var TERMS_PAGE_NAME = '.terms';
function createApplicationRequest() {
  return {
    type: actions.CREATE_CLIENT_APPLICATION_REQUEST
  };
}
function createApplicationSuccess(application) {
  return {
    type: actions.CREATE_CLIENT_APPLICATION_SUCCESS,
    application: application
  };
}
function createApplicationFailure(error) {
  return {
    type: actions.CREATE_CLIENT_APPLICATION_FAILURE,
    error: error
  };
}
function resetModalState() {
  return {
    type: actions.RESET_MODAL_STATE
  };
}
function createContractRequest() {
  return {
    type: actions.CREATE_CONTRACT_REQUEST
  };
}
function createContractSuccess(contract) {
  return {
    type: actions.CREATE_CONTRACT_SUCCESS,
    contract: contract
  };
}
function createContractError(error) {
  return {
    type: actions.CREATE_CONTRACT_FAILURE,
    error: error
  };
}
function openRequestAccessModal(_ref) {
  var asset = _ref.asset,
    getPath = _ref.getPath,
    openModal = _ref.openModal;
  return function (dispatch, getState) {
    var state = getState();
    var profile = _exchangeUiPortalsStore.selectors.selectProfile(state);
    var memberOfOrgs = profile.memberOfOrganizations || [];
    var parentOrganizationIds = asset.organization.parentOrganizationIds || [];

    // The second condition is to support proxy users. Proxy users do not have memberOfOrganizations property in their profile
    // but they do have the organizationId where they were created.
    // Take into account that the asset may have been created in any Business Group so asset.organization.id will be the
    // BusinessGroupId and not the masterOrganizationId (which would match profile.organizationId). That is why we compare first
    // with parentOrganizationIds[0] which will be the masterOrg if the asset.organization is a BusinessGroup.
    // If parentOrganizationIds[0] is undefined, it means the asset was created in the masterOrg, therefore asset.organization.id
    // will be the master org and we can use it to compare with the profile's organizationId property.
    var isAssetOrganizationMember = memberOfOrgs.some(function (org) {
      return org.id === asset.organization.id;
    }) || profile.organizationId === (parentOrganizationIds[0] || asset.organization.id);
    if (profile && isAssetOrganizationMember) {
      dispatch(resetModalState());
      openModal();
    } else {
      global.location.replace(getPath('login'));
    }
  };
}
function createContract(_ref2, getPath, openModal) {
  var assetType = _ref2.assetType,
    masterOrganizationId = _ref2.masterOrganizationId,
    applicationId = _ref2.applicationId,
    apiInstanceId = _ref2.apiInstanceId,
    environmentId = _ref2.environmentId,
    slaTierId = _ref2.slaTierId,
    organizationId = _ref2.organizationId,
    groupId = _ref2.groupId,
    assetId = _ref2.assetId,
    version = _ref2.version,
    versionGroup = _ref2.versionGroup;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(dispatch, getState, _ref3) {
      var config, state, context, contractService, createRequest, contract, applicationPath, modalProps, trackPayloadProps;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config = _ref3.config;
            state = getState();
            context = _exchangeUiPortalsStore.selectors.selectContext(state);
            dispatch(createContractRequest());
            contractService = new _exchangeApiClient.ContractService(config);
            createRequest = contractService.create({
              context: context,
              masterOrganizationId: masterOrganizationId,
              applicationId: applicationId,
              apiInstanceId: apiInstanceId,
              environmentId: environmentId,
              slaTierId: slaTierId,
              organizationId: organizationId,
              groupId: groupId,
              assetId: assetId,
              version: version,
              versionGroup: versionGroup
            });
            _context.prev = 6;
            _context.next = 9;
            return createRequest;
          case 9:
            contract = _context.sent;
            applicationPath = getPath('applicationDetail', {
              applicationId: applicationId.toString()
            });
            dispatch(createContractSuccess(contract));
            modalProps = {
              groupId: groupId,
              assetId: assetId,
              version: version,
              applicationPath: applicationPath
            };
            trackPayloadProps = {
              assetType: assetType,
              hasTermsPage: (_exchangeUiPortalsStore.selectors.selectPages(state, {
                groupId: groupId,
                assetId: assetId,
                version: version
              }) || []).some(function (page) {
                return page.path === TERMS_PAGE_NAME;
              })
            };
            openModal(modalProps, trackPayloadProps);
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](6);
            dispatch(createContractError(_context.t0));
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 17]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
}
function createContractForAPIGroup(_ref5, getPath, openModal) {
  var masterOrganizationId = _ref5.masterOrganizationId,
    applicationId = _ref5.applicationId,
    apiInstanceId = _ref5.apiInstanceId,
    slaTierId = _ref5.slaTierId,
    organizationId = _ref5.organizationId,
    groupId = _ref5.groupId,
    assetId = _ref5.assetId,
    version = _ref5.version,
    versionGroup = _ref5.versionGroup;
  return /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch, getState, _ref6) {
      var config, state, context, contractService, createRequest, contract, applicationPath, modalProps, trackPayloadProps;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            config = _ref6.config;
            state = getState();
            context = _exchangeUiPortalsStore.selectors.selectContext(state);
            dispatch(createContractRequest());
            contractService = new _exchangeApiClient.ContractService(config);
            createRequest = contractService.createForAPIGroup({
              context: context,
              masterOrganizationId: masterOrganizationId,
              applicationId: applicationId,
              apiGroupInstanceId: apiInstanceId,
              slaTierId: slaTierId,
              organizationId: organizationId,
              groupId: groupId,
              assetId: assetId,
              version: version,
              versionGroup: versionGroup
            });
            _context2.prev = 6;
            _context2.next = 9;
            return createRequest;
          case 9:
            contract = _context2.sent;
            applicationPath = getPath('applicationDetail', {
              applicationId: applicationId.toString()
            });
            dispatch(createContractSuccess(contract));
            modalProps = {
              groupId: groupId,
              assetId: assetId,
              version: version,
              applicationPath: applicationPath
            };
            trackPayloadProps = {
              assetType: 'api-group',
              hasTermsPage: (_exchangeUiPortalsStore.selectors.selectPages(state, {
                groupId: groupId,
                assetId: assetId,
                version: version
              }) || []).some(function (page) {
                return page.path === TERMS_PAGE_NAME;
              }),
              hasUnderlyingTerms: _store.selectors.hasUnderlyingTerms(state, {
                groupId: groupId,
                assetId: assetId,
                versionGroup: versionGroup
              })
            };
            openModal(modalProps, trackPayloadProps);
            _context2.next = 20;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](6);
            dispatch(createContractError(_context2.t0));
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[6, 17]]);
    }));
    return function (_x4, _x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }();
}
//# sourceMappingURL=actions.js.map